import {Component, Inject, OnInit} from '@angular/core';
import {CardAssignment} from '../card-assignment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Router} from '@angular/router';

@Component({
    selector: 'app-assignments-card-modal',
    templateUrl: './assignments-card-modal.component.html',
    styleUrls: ['./assignments-card-modal.component.css']
})
export class AssignmentsCardModalComponent implements OnInit {

    assignments: CardAssignment[] = [];
    displayedColumns: string[] = ['Due', 'Class', 'Assignment'];

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private dialogRef: MatDialogRef<AssignmentsCardModalComponent>) {
    }

    ngOnInit() {
        this.assignments = this.data.assignments;
    }

    viewAllClick() {
        this.router.navigateByUrl('/student360/assignments');
        this.dialogRef.close();
    }

    checkIfMissing(assignment: CardAssignment) {
        // If missing return the isMissing class
        if (assignment.IsMissing) {
            return 'isMissing';
        }
    }

    closeClick() {
        this.dialogRef.close();
    }

}
